import { render, staticRenderFns } from "./roast.vue?vue&type=template&id=16fe57fb&scoped=true&"
import script from "./roast.vue?vue&type=script&lang=js&"
export * from "./roast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fe57fb",
  null
  
)

export default component.exports